import * as React from "react";
import { Button, Fab, Stack, TextField } from "@mui/material";
import { AddRounded, RemoveRounded } from "@mui/icons-material";

import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";
import { IXProductDetailsProps } from "../../../../utils/interfaces/containers/XProductDetails.interfaces";
import { IArticleData } from "../../../../utils/interfaces/common/XArticle.interfaces";
import { useCart } from "../../../../hooks/useCart";
import { ICartItem } from "../../../../utils/constants/dynamic/article";

const QuantitySelector: React.FC<
  IXProductDetailsProps & {
    article: IArticleData;

    onChange: (args: TSetUrlParamsArgs) => Promise<void>;

    urlParams?: TSetUrlParamsArgs;
  }
> = ({
  inputMode = "minus_plus",
  detailsGap = "10px",
  urlParams = {},
  article,
  onChange,
}) => {
  const { cart, setCart } = useCart();

  const cartItem = cart.carts.find((e) => e.id === article.id);

  let value =
    urlParams && typeof urlParams.qty === "number"
      ? urlParams.qty
      : cartItem
      ? cartItem.qty
      : 0;

  const isMax = article.isInfinite ? false : value >= article.qty;

  if (!article.isInfinite && value > article.qty) value = article.qty;

  return (
    <Stack direction="row" spacing={2} pt={detailsGap} mt={2}>
      {inputMode === "minus_plus" && (
        <Stack
          direction="row"
          spacing={1}
          className="XProductDetails_QtyInput"
          alignItems="center"
        >
          <Fab
            color="primary"
            aria-label="remove"
            className="XProductDetails_QtyInput_Btn"
            disabled={value === 0}
            onClick={async () => {
              await onChange({ qty: value - 1 });
            }}
          >
            <RemoveRounded />
          </Fab>
          <TextField
            hiddenLabel
            type="number"
            inputProps={{
              min: 0,
              max: article.isInfinite ? undefined : article.qty,
            }}
            value={value}
            onChange={async (e) => {
              await onChange({ qty: parseInt(e.target.value ?? "0") });
            }}
            className="XProductDetails_QtyInput_Field"
            size="small"
            placeholder="1"
          />
          <Fab
            color="primary"
            aria-label="add"
            className="XProductDetails_QtyInput_Btn"
            disabled={isMax}
            onClick={async () => {
              await onChange({ qty: value + 1 });
            }}
          >
            <AddRounded />
          </Fab>
        </Stack>
      )}
      <Button
        className="XProductDetails_AddToCart"
        disabled={!cartItem && value === 0}
        onClick={async () => {
          setCart((old) => {
            let carts: ICartItem[] = [...old.carts];

            // NEW IN THE SHOPPING CART
            if (!cartItem) {
              carts.push({
                ...article,
                qty: value,
                selectedOptions: { ...urlParams },
              });
            }

            // EXISTING ELEMENT
            else {
              // IF WE SET THE QUANTITY TO 0 WE WANT TO REMOVE
              if (value === 0) {
                carts = carts.filter((e) => e.id !== article.id);
              } else {
                carts = carts.map((e) =>
                  e.id === article.id
                    ? {
                        ...e,
                        qty: value,
                        selectedOptions: { ...urlParams },
                      }
                    : e
                );
              }
            }

            return { ...old, carts };
          });
        }}
      >
        {value === 0 && cartItem ? "Retirer Au Panier" : "Ajouter Au Panier"}
      </Button>
    </Stack>
  );
};

export default QuantitySelector;
